var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"price"},[(_vm.priceOriginal !== '')?_c('del',{staticClass:"original-number"},[_vm._v(_vm._s(_vm.priceOriginal))]):_vm._e(),(_vm.priceCurrent !== '')?_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.priceCurrent))]):_vm._e(),_c('span',{staticClass:"unit"},[_vm._v(_vm._s(_vm.hasUnit ? '/ ' + _vm.priceUnit : ''))])])
}
var staticRenderFns = []

export { render, staticRenderFns }